module.exports = __webpack_public_path__ + "img/img-3.37b5247e.svg";